import { parse } from 'cookie';

export const parseCookie = (context) =>
  context ? parse(context.headers.cookie || '') : parse(document.cookie);

export default parseCookie;
